import { Component } from '@angular/core';

@Component({
  selector: 'mprd-cyber-care-claim',
  templateUrl: './cyber-care-claim.component.html',
  styleUrls: ['./cyber-care-claim.component.css'],
})
export class CyberCareClaimComponent {
  constructor() {}
}
